/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Contact_Extend_Wrapup_SecondsInputs */

const en_forms_templates_settings_contact_extend_wrapup_seconds = /** @type {(inputs: Forms_Templates_Settings_Contact_Extend_Wrapup_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconds`)
};

const de_forms_templates_settings_contact_extend_wrapup_seconds = /** @type {(inputs: Forms_Templates_Settings_Contact_Extend_Wrapup_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconds`)
};

/**
* | output |
* | --- |
* | "Seconds" |
*
* @param {Forms_Templates_Settings_Contact_Extend_Wrapup_SecondsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_contact_extend_wrapup_seconds = /** @type {((inputs?: Forms_Templates_Settings_Contact_Extend_Wrapup_SecondsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Contact_Extend_Wrapup_SecondsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_contact_extend_wrapup_seconds(inputs)
	return de_forms_templates_settings_contact_extend_wrapup_seconds(inputs)
});